import { render, staticRenderFns } from "./LottieIntroAniHandler.vue?vue&type=template&id=29680d12&"
import script from "./LottieIntroAniHandler.vue?vue&type=script&lang=js&"
export * from "./LottieIntroAniHandler.vue?vue&type=script&lang=js&"
import style0 from "./LottieIntroAniHandler.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports